export const ADDITIONAL_DATA_MAX_LENGTH = 1024;

export const isAdditionalDataTooLong = value =>
  (value || '').length > ADDITIONAL_DATA_MAX_LENGTH;

export const validateEmail = email => {
  if (!email || email.length === 0) {
    return false;
  }

  //From here
  //http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
  var re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};
